import SchoolAdminDashboard from "../schoolAdminDashboard";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import { CircularProgress, Paper, Typography } from "@material-ui/core";
import CreateSeason from "../Popups/CreateSeason";
import { useEffect } from "react";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import AddEditSchedule from "../Popups/AddEditSchedule";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllWeekList,
  setCurrentSeason,
  setCurrentSeasonInUserProfile,
  setEditSchedule,
  setOpponentSchoolList,
  setScheduleInformation,
  toggleBuildSchedulePopup,
} from "../../../Redux/Actions/LoginActions";
import TableWithPagination from "../../../Common/Tables/TableWithPagination";
import { seasonTableColumns } from "../../tableColumns/seasonTableColumns";
import CustomSearch from "../../../Common/CustomSearch";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../utils/constant";
import { openSuccessPopup } from "../../../Redux/Actions/PopupActions";
import PastSeason from "../PastSeason/PastSeason";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const Seasons = () => {
  const [tabValue, setTabValue] = useState("");
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });

  const schoolId = getFromLocalStorage("schoolId");
  const schoolName = getFromLocalStorage("schoolName");
  const [recordNotFound, setRecordNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const buildSchedulePopup = useSelector(
    (state) => state.loggedInUser.buildSchedulePopup
  );
  const currentSeason = useSelector(
    (state) => state.loggedInUser.currentSeason
  );
  const permissionRights = useSelector(({ loggedInUser }) =>
    loggedInUser.userProfile.permissionRights.map((item) => item.displayName)
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      id: loggedInUser.userProfile.userId,
      role: role,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
      permissionRights: loggedInUser.userProfile.permissionRights.map(
        (item) => item.displayName
      ),
    };
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    getCurrentSeason();
    if (currentSeason) {
      fetchSeasonWeeks();
    }
  }, []);

  useEffect(() => {
    if (currentSeason) {
      fetchSeasonWeeks();
    }
  }, [currentSeason]);

  const fetchSeasonWeeks = () => {
    userService
      .getAllSeasonWeeks(schoolId, currentSeason.id)
      .then((res) => {
        setAllWeekList(dispatch, res.data.data);
      })
      .catch((err) => {
        setAllWeekList(dispatch, []);
        console.error(err);
      });
  };

  const getCurrentSeason = () => {
    userService
      .getCurrentSeason(schoolId)
      .then((res) => {
        const allSeasonList = res.data.data;
        const currentSeason = allSeasonList.filter((item) => {
          return item.currentSession === true;
        });
        if (currentSeason.length > 0) {
          setCurrentSeason(dispatch, currentSeason[0]);
          getOpponentSchoolList(schoolName);
          fetchSchedulesByPage(pageState.page, pageState.pageSize);
        } else {
          setCurrentSeason(dispatch, "");
          setLoading(false);
        }
      })
      .catch((err) => {
        setCurrentSeason(dispatch, "");
        console.error(err);
      });
  };

  const getOpponentSchoolList = (schoolName) => {
    userService.getAllSchoolListing().then((res) => {
      var schoolList = [];
      schoolList = res.data.data.schools;
      const filteredSchoolList = schoolList.filter(function (item) {
        return item.schoolName !== schoolName;
      });
      setOpponentSchoolList(dispatch, filteredSchoolList);
    }).catch = (err) => {
      console.error(err);
    };
  };

  const fetchSchedulesByPage = (page, size) => {
    setPageState((old) => ({ ...old, isLoading: true }));
    userService
      .getSchedules(schoolId, page, size)
      .then((res) => {
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: res.data.data.schedules,
          total: res.data.data.total,
        }));
        setLoading(false);
        if (recordNotFound) {
          setRecordNotFound(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChange = (event, newValue) => {
    if (tabValue == "") {
      setValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const handleClick = () => {
    toggleCreateSeasonDialog(true);
    setMsg("Create a new season");
  };

  const handleSubmit = (
    radioValue,
    isCurrentSeason,
    getAllSeasonList,
    setRadioValue
  ) => {
    userService
      .createSeason(schoolId, radioValue, isCurrentSeason)
      .then((res) => {
        userService.addActivitySeasonOrScheduleAdded(
          null,
          res.data.data.id,
          schoolId,
          userInfo.id,
          "CELL",
          "SEASON_ADDED"
        );
        setCurrentSeasonInUserProfile(dispatch, res.data.data);
        getAllSeasonList();
        getCurrentSeason();
        toggleCreateSeasonDialog(false);
        setRadioValue("");
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Season Created Successfully",
            open: true,
          },
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const toggleCreateSeasonDialog = (status) => {
    setOpen(status);
  };

  const setNewPage = (newPage) => {
    setPageState((old) => ({
      ...old,
      page: newPage,
    }));
  };

  const setNewPageSize = (newPageSize) => {
    setPageState((old) => ({
      ...old,
      pageSize: newPageSize,
    }));
  };

  const searchSchedule = (query, page, size) => {
    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setSearchQuery(query);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService
      .searchSchedule(query, schoolId, page, size)
      .then((res) => {
        const { schedules, total } = res.data.data;
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: schedules,
          total: total,
          page: page,
        }));
        schedules.length == 0
          ? setRecordNotFound(true)
          : setRecordNotFound(false);
      })
      .catch((err) => {
        setRecordNotFound(true);
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: [],
          total: 0,
          page: page,
        }));
      });
  };
  return (
    <>
      <SchoolAdminDashboard />
      <div
        className={
          isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
        }
      >
        <div id="tabs">
          <div className="row" id="mobTop-5">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mng-header p-10 mng-padding">
              <Tabs
                className="tab-nm"
                value={tabValue ? tabValue : value}
                onChange={handleChange}
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab
                  label="Current Season"
                  {...a11yProps(0)}
                  style={{ minWidth: "10%" }}
                />
                <Tab label="Past Season" {...a11yProps(1)} />
              </Tabs>
              {(userInfo.role == userRoles.ROLE_SCHOOL_ADMIN ||
                permissionRights.includes("Add/ Remove Schedule")) && (
                <button
                  className="addBtnn2 mng-padding"
                  onClick={() => handleClick()}
                >
                  <AddIcon className="mx-1 addIconSc " />
                  Create New Season
                </button>
              )}
            </div>
          </div>
          <TabPanel value={tabValue ? tabValue : value} index={0}>
            {loading && (
              <div className="content-layout-loading-animation">
                <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                  <CircularProgress
                    className="rounded-circle"
                    color="success"
                    sx={{ fontSize: 10, color: "#002244" }}
                    disableShrink
                  />
                </div>
              </div>
            )}
            {!loading && (
              <>
                {" "}
                <div className="d-flex items-center justify-between">
                  <h3>{currentSeason ? currentSeason.years : ""}</h3>
                </div>
                <Paper className="mg-top-10 pad-top-20">
                  {currentSeason && currentSeason.years && pageState.data && (
                    <CustomSearch
                      searchQuery={searchQuery}
                      searchedRecord={searchedRecord}
                      setSearchedRecord={setSearchedRecord}
                      setSearchQuery={setSearchQuery}
                      getDataByPage={fetchSchedulesByPage}
                      searchData={searchSchedule}
                      pageState={pageState}
                      setRecordNotFound={setRecordNotFound}
                    />
                  )}
                  <div className="pagination-table-container">
                    <TableWithPagination
                      tableColumns={seasonTableColumns}
                      pageState={pageState}
                      searchQuery={searchQuery}
                      getDataByPage={fetchSchedulesByPage}
                      setNewPage={setNewPage}
                      setNewPageSize={setNewPageSize}
                      handleRowClick={(param) => {
                        setScheduleInformation(dispatch, param);
                        setEditSchedule(dispatch, true);
                        toggleBuildSchedulePopup(dispatch, true);
                      }}
                    />
                    {!currentSeason && (
                      <div className="no-data-table-message bold">
                        <p className="fs-22">No Current Season Selected</p>
                      </div>
                    )}
                  </div>
                </Paper>
              </>
            )}
          </TabPanel>
          <TabPanel value={tabValue ? tabValue : value} index={1}>
            <PastSeason />
          </TabPanel>
        </div>
        <CreateSeason
          successPopUp={open}
          toggleSuccessDialog={toggleCreateSeasonDialog}
          msg={msg}
          handleSubmit={handleSubmit}
        />

        <AddEditSchedule
          successPopUp={buildSchedulePopup}
          toggleSuccessDialog={toggleBuildSchedulePopup}
          fetchSchedulesByPage={fetchSchedulesByPage}
          pageState={pageState}
          fetchSeasonWeeks={fetchSeasonWeeks}
          searchSchedule={searchSchedule}
          searchedRecord={searchedRecord}
          searchQuery={searchQuery}
        />
      </div>
    </>
  );
};

export default Seasons;
